module.exports = __webpack_public_path__ + "img/escritorio.b29ea88a.png";